import React from "react";
import { Link } from "react-router-dom";
import { Logo } from "@/components/Logo";
import { Diamond } from "lucide-react";

export default function Footer() {
  return (
    <footer className="border-t border-[#C9A24B]/15 bg-[#08080a] mt-24">
      <div className="max-w-7xl mx-auto px-6 lg:px-12 py-14 grid grid-cols-1 md:grid-cols-4 gap-10">
        <div className="md:col-span-2">
          <Logo />
          <p className="text-[#A19E95] text-sm mt-5 max-w-sm leading-relaxed">
            MYSE connecte les particuliers et les entreprises aux plus grands artistes et personnalités
            pour des événements véritablement inoubliables.
          </p>
          <p className="font-script text-3xl gold-text mt-6">Good People, Great Moments</p>
        </div>
        <div>
          <h4 className="text-xs uppercase tracking-[0.25em] text-[#C9A24B] mb-4">Navigation</h4>
          <ul className="space-y-2 text-sm text-[#A19E95]">
            <li><Link to="/artistes" className="hover:text-white">Artistes</Link></li>
            <li><Link to="/comment-ca-marche" className="hover:text-white">Comment ça marche</Link></li>
            <li><Link to="/a-propos" className="hover:text-white">À propos</Link></li>
            <li><Link to="/contact" className="hover:text-white">Contact</Link></li>
          </ul>
        </div>
        <div>
          <h4 className="text-xs uppercase tracking-[0.25em] text-[#C9A24B] mb-4">Événements</h4>
          <ul className="space-y-2 text-sm text-[#A19E95]">
            <li>Mariages</li>
            <li>Anniversaires</li>
            <li>Événements privés</li>
            <li>Expériences VIP</li>
          </ul>
        </div>
      </div>
      <div className="border-t border-white/5 py-6 text-center text-xs text-[#6E6B63] flex items-center justify-center gap-2">
        <Diamond size={12} className="text-[#C9A24B]" />
        © {new Date().getFullYear()} MYSE — Meet Your Star Exclusively. Tous droits réservés.
      </div>
    </footer>
  );
}
